<template>
  <div class="resetNickname">
    <mt-header title="修改昵称" style="height:8vh;font-size:18px;">
      <router-link to="/me" slot="left">
        <mt-button icon="back"></mt-button>
      </router-link>
    </mt-header>

    <div class="nicknameFrom">
      <div class="nicknameInput">
        <input v-model="newNickname" @blur="NicknameBlur" placeholder="请输入昵称"/>
      </div>
      <p>2-20个字符，可由中英文、数字、“_”、“-”组成</p>
      <!-- <p>{{nicknameTips}}</p> -->
    </div>

    <mt-button style="width:90vw;margin:8vh 0 0 5vw;" type="primary" @click="commitNickname()">提交</mt-button>
  </div>
</template>
<script>
import { Toast } from 'mint-ui'
export default {
  name:'resetNickname',
  data(){
    return {
      newNickname:'',
      oldNickname:'',
      rule:false,
      accountId:'',
      comit:false//控制提交按钮
    }
  },
  watch:{
    newNickname(){
      this.newNickname = this.newNickname.substr(0,20)
    }
  },
  mounted(){
    this.init()
    this.STATE.state.bottomindex='btnFive'
  },
  methods:{
    // 初始化，反显
    init:function () {
      let _this = this
      this.axios({
          method : 'GET',
          url : "/url/userName/getUserInformation?accountId="+sessionStorage.getItem('loginId'),
      }).then(function(res){
        _this.newNickname = res.data.account.name
        _this.oldNickname = res.data.account.name
        _this.accountId = res.data.accountId
        _this.comit = false
      })
    },
    // 失去焦点
    NicknameBlur(){
      this.rules(this.newNickname)
      // if(this.rule === true){
      //   this.again(this.newNickname,'blur')
      // }
    },
    // 提交
    commitNickname:function () {
      if(this.comit == false){
        this.comit = true

        this.rules(this.newNickname)
        if(this.rule === true){
          this.again(this.newNickname)
        }
      }
    },
    rules:function (nicknameVal) {
        let reg = /^[a-zA-Z0-9_\u4e00-\u9fa5\-]{2,20}$/
        //全为数字
        let regNum = /^[0-9]+$/
        //全为符号'_'和'-'
        let regSym = /^[_\-]+$/

        if(this.oldNickname === this.newNickname){
          this.comit = false
          this.rule = false
        }else if(nicknameVal === ''){
          Toast({
            message: '请输入昵称',
            position: 'middle',
            duration: 2000
          })
          this.rule = false
        }else if(reg.test(nicknameVal)===false){
          // 提示框
          Toast({
            message: '昵称格式不正确',
            position: 'middle',
            duration: 2000
          })
          this.rule = false
        }else if(regNum.test(nicknameVal)){
          // 提示框
          Toast({
            message: '不可全由数字组成',
            position: 'middle',
            duration: 2000
          })
          this.rule = false
        }else if(regSym.test(nicknameVal)){
          // 提示框
          Toast({
            message: '不可全由符号组成',
            position: 'middle',
            duration: 2000
          })
          this.rule = false
        }else {
          this.rule = true
        }
    },
    again:function (nicknameVal,blur) {
          let _this = this
          this.axios({
              method : 'POST',
              url : "/url/account/checkUserName",
              params : {userName :nicknameVal},
              dataType : 'json'
          }).then(function(res){
              //不重复为true
              if(res.data.success === true){
                  //验证 敏感词
                  _this.sensitive(nicknameVal,blur)
              }else{//昵称重复
                  Toast({
                    message: '该昵称已被使用，请重新输入',
                    position: 'middle',
                    duration: 2000
                  })
                  _this.comit = false
              }
          })
    },
    sensitive:function(nicknameVal,blur){
        let _this = this
        this.axios({
            method : 'POST',
            url : "/url/userName/getShieldingWords",
            params : {userName :nicknameVal},
            dataType : 'json'
        }).then(function(res){
            //不重复为true
            if(res.data.success === true){//无 敏感词
                if(blur !== 'blur'){
                    //提交
                    _this.commit(nicknameVal)
                }
            }else{//存在 敏感词
              Toast({
                message: res.data.msg,
                position: 'middle',
                duration: 2000
              })
               _this.comit = false
            }
        })
    },
    commit:function (nicknameVal) {
        let _this = this
        this.axios({
            method : 'POST',
            url : "/url/userName/updateUserName",
            params : {userName :nicknameVal,accountId:_this.accountId},
            dataType : 'json'
        }).then(function(res){
            //提交成功
            if(res.data.success === true){
                Toast({
                  message: '修改成功',
                  position: 'middle',
                  duration: 2000
                })
                _this.init()
            }
        })
    },
  }
}
</script>
<style scoped>
.resetNickname{
  background-color:#f0eff5;
  padding-bottom:1px;
  height: 99vh;
}

.nicknameInput input{
  width: 98vw;
  height: 40px;;
  border: none;
  padding-left: 2vw;
  margin-bottom: 10px;
}
.nicknameFrom p{
  color: #666;
  padding: 0 4vw;
}
</style>



// WEBPACK FOOTER //
// resetNickname.vue?2be853e5